
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Toast } from "vant";
import {
    UserService,
} from "src/services";

@Component
export default class InformationPage extends Vue
{
    // 用于刷新子组件
    private keyNum: any = 0;

    // 样式
    private pageStyle: any = {};

    /**
     * 父组件传值
     * @private
     * @returns object
     */
    @Prop({type: Object, default: {}})
    private data: {};

    // 主标题字体大小
    private subStyle: any = {};

    /**
     * 店铺信息
     * @private
     * @returns void
     */
     private get orgInfo(): any
    {
        return this.$store.getters.orgInfo || {};
    }

    /**
     * 获取店铺信息
     * @private
     * @returns void
     */
     private async getOrgInfo(code: string): Promise<void>
    {
        try
        {
            if (!code)
            {
                return;
            }

            let {content: result} =  await UserService.instance.getOrgInfo(code);

            if(result.data)
            {
                if (result.data.errorPage)
                {
                    this.$router.replace({name: "storeClose"})
                }
                else
                {
                    this.$store.dispatch("setOrgInfo", result.data);
                }
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 组件创建钩子
     */
     protected created() {
        let appId = localStorage.getItem("appid");
        if(appId)
        {
            // 获取机构信息
            this.getOrgInfo(appId);
        }
    }

    /**
     * 值发生变化
     * @protected
     * @returns void
     */
     @Watch("data", {immediate: true, deep: true})
    private onDataChange(newValue: any): void
    {
        // 背景样式
        this.pageStyle = {'margin': newValue.properties.moduleSettings.upAndDown + 'px 0 0 0' , 'background-image': newValue.properties.moduleSettings.bgImg.fullPath ? 'url(' + newValue.properties.moduleSettings.bgImg.fullPath +')' : ''};
    }
}
